module.exports = __webpack_public_path__ + "85ed568a08233d6a1c571f6c97f48549.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-ultralight.ttf
// module id = 95
// module chunks = 0